/* Alkemia House theme JS — cart drawer, product forms, oils accordion,
   bundle builder, Jalupro filters, toasts. No dependencies. */
(function () {
  'use strict';

  var cfg = window.theme || {};
  /* The AJAX cart endpoints MUST end in .js — /cart/add answers with an HTML
     redirect, /cart/add.js answers with JSON. Enforce it whatever config says. */
  function ajaxUrl(url, fallback) {
    url = (url || fallback).split('?')[0];
    return /\.js$/.test(url) ? url : url + '.js';
  }
  var CART_URL = ajaxUrl(cfg.cartUrl, '/cart');
  var CART_ADD_URL = ajaxUrl(cfg.cartAddUrl, '/cart/add');
  var CART_CHANGE_URL = ajaxUrl(cfg.cartChangeUrl, '/cart/change');

  /* ───────────────────── Lenis smooth scroll ─────────────────────
     Site-wide, same settings as the Claude Design build
     (lerp .1, wheelMultiplier 1). Skipped for reduced-motion users
     and when the editor is open. Native scroll keeps working either way. */
  var lenis = null;
  var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if (window.Lenis && !reduceMotion && !(window.Shopify && window.Shopify.designMode)) {
    lenis = new window.Lenis({ lerp: 0.1, wheelMultiplier: 1, smoothWheel: true });
    (function raf(t) { lenis.raf(t); requestAnimationFrame(raf); })(0);
    window.vyLenis = lenis;
  }

  /* Height of the pinned bars (Alkemia bar + brand header) for anchor offsets */
  function stickyOffset() {
    var h = 0;
    ['shopify-section-alkemia-bar', 'shopify-section-vybes-header', 'shopify-section-jalupro-header'].forEach(function (id) {
      var el = document.getElementById(id);
      if (el) h += el.offsetHeight;
    });
    return h;
  }
  function scrollToEl(el, immediate) {
    var top = el.getBoundingClientRect().top + window.scrollY - stickyOffset() - 8;
    if (lenis) lenis.scrollTo(Math.max(0, top), { duration: immediate ? 0 : 1.2 });
    else window.scrollTo({ top: Math.max(0, top), behavior: immediate ? 'auto' : 'smooth' });
  }
  // Same-page anchor links (header nav, hero CTAs) glide instead of jumping
  document.addEventListener('click', function (e) {
    var a = e.target.closest('a[href*="#"]');
    if (!a || a.target === '_blank' || e.metaKey || e.ctrlKey) return;
    var url;
    try { url = new URL(a.getAttribute('href'), location.href); } catch (err) { return; }
    if (url.pathname !== location.pathname || url.search !== location.search || !url.hash || url.hash === '#') return;
    var target = document.getElementById(decodeURIComponent(url.hash.slice(1)));
    if (!target) return;
    e.preventDefault();
    history.pushState(null, '', url.hash);
    scrollToEl(target);
  });
  // Landing on /collections/vybes#bundle: correct for the sticky bars
  if (location.hash) {
    window.addEventListener('load', function () {
      var t = document.getElementById(decodeURIComponent(location.hash.slice(1)));
      if (t) setTimeout(function () { scrollToEl(t, true); }, 50);
    });
  }

  /* ───────────────────── Money ───────────────────── */
  function formatMoney(cents, format) {
    format = format || cfg.moneyFormat || 'EGP {{ amount }}';
    var value = (cents / 100);
    function delimit(num, precision) {
      var parts = num.toFixed(precision).split('.');
      parts[0] = parts[0].replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,');
      return parts.join('.');
    }
    var text = '';
    var m = format.match(/\{\{\s*(\w+)\s*\}\}/);
    var key = m ? m[1] : 'amount';
    switch (key) {
      case 'amount_no_decimals': text = delimit(value, 0); break;
      case 'amount_with_comma_separator': text = value.toFixed(2).replace('.', ','); break;
      case 'amount_no_decimals_with_comma_separator': text = delimit(value, 0); break;
      default:
        text = value % 1 === 0 ? delimit(value, 0) : delimit(value, 2);
    }
    return format.replace(/\{\{\s*\w+\s*\}\}/, text);
  }
  window.vyFormatMoney = formatMoney;

  /* ───────────────────── Toast ───────────────────── */
  var toastEl = document.getElementById('vy-toast');
  var toastTimer;
  function toast(msg) {
    if (!toastEl) return;
    toastEl.querySelector('.vy-toast__msg').textContent = msg;
    toastEl.hidden = false;
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () { toastEl.hidden = true; }, 2600);
  }
  window.vyToast = toast;

  /* ───────────────────── Cart drawer ───────────────────── */
  var drawer = document.getElementById('CartDrawer');
  var scrim = document.getElementById('CartDrawerScrim');

  function updateCounts(cart) {
    document.querySelectorAll('[data-cart-count]').forEach(function (el) {
      el.textContent = cart.item_count;
    });
  }

  function renderDrawer(cart) {
    updateCounts(cart);
    document.dispatchEvent(new CustomEvent('cart:updated', { detail: cart }));
    if (!drawer) return;
    var list = drawer.querySelector('[data-drawer-items]');
    var subtotal = drawer.querySelector('[data-drawer-subtotal]');
    if (!list || !subtotal) return;
    subtotal.textContent = formatMoney(cart.total_price);
    if (!cart.items.length) {
      list.innerHTML = '<div class="vy-drawer__empty"><span class="vy-star" aria-hidden="true"></span>' +
        (drawer.dataset.emptyText || 'Your bag is empty. Go pick a vybe.') + '</div>';
      return;
    }
    list.innerHTML = cart.items.map(function (item, i) {
      var line = i + 1;
      var img = item.image
        ? '<img class="vy-line__img" src="' + item.image.replace(/(\.[a-z]{3,4})(\?|$)/, '_160x$1$2') + '" alt="" loading="lazy">'
        : '<span class="vy-line__img"></span>';
      var variant = item.product_has_only_default_variant || item.variant_title === 'Default Title'
        ? '' : '<span class="vy-line__variant">' + escapeHtml(item.variant_title || '') + '</span>';
      return '<div class="vy-line" data-line="' + line + '">' + img +
        '<div><a class="vy-line__name" href="' + item.url + '">' + escapeHtml(item.product_title) + '</a>' + variant +
        '<div class="vy-line__qty">' +
        '<button type="button" data-line-minus aria-label="Decrease quantity">−</button>' +
        '<span>' + item.quantity + '</span>' +
        '<button type="button" data-line-plus aria-label="Increase quantity">+</button>' +
        '</div>' +
        '<button type="button" class="vy-line__remove" data-line-remove>' + (drawer.dataset.removeText || 'Remove') + '</button>' +
        '</div>' +
        '<span class="vy-line__price">' + formatMoney(item.final_line_price) + '</span>' +
        '</div>';
    }).join('');
  }

  function hexToRgb(hex) {
    if (!hex) return null;
    var h = String(hex).trim().replace('#', '');
    if (h.length === 3) h = h.replace(/(.)/g, '$1$1');
    if (h.length !== 6) return null;
    var n = parseInt(h, 16);
    return [(n >> 16) & 255, (n >> 8) & 255, n & 255].join(',');
  }
  window.vyHexToRgb = hexToRgb;

  function escapeHtml(s) {
    return String(s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  function fetchCart() {
    return fetch(CART_URL, { credentials: 'same-origin' })
      .then(function (r) { return r.json(); });
  }

  function refreshDrawer() { return fetchCart().then(renderDrawer); }

  function showDrawer() {
    if (!drawer) return;
    closeMobNav();
    drawer.classList.add('is-open');
    scrim && scrim.classList.add('is-open');
    drawer.setAttribute('aria-hidden', 'false');
    document.documentElement.style.overflow = 'hidden';
    if (lenis) lenis.stop();
  }
  function openDrawer() {
    if (!drawer) return;
    // Open first, then fill — the drawer must appear even if /cart.js is slow or fails
    showDrawer();
    refreshDrawer().catch(function () { /* keep server-rendered contents */ });
  }
  function closeDrawer() {
    if (!drawer) return;
    drawer.classList.remove('is-open');
    scrim && scrim.classList.remove('is-open');
    drawer.setAttribute('aria-hidden', 'true');
    document.documentElement.style.overflow = '';
    if (lenis) lenis.start();
  }
  window.vyOpenCart = openDrawer;

  function changeLine(line, qty) {
    return fetch(CART_CHANGE_URL, {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ line: line, quantity: qty })
    }).then(function (r) { return r.json(); }).then(renderDrawer);
  }

  function addItems(items, message) {
    return fetch(CART_ADD_URL, {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: items })
    }).then(function (r) {
      if (!r.ok) return r.json().then(function (e) { throw e; });
      return r.json();
    }).then(function () {
      if (message) toast(message);
      // Always re-read the cart so every [data-cart-count] badge updates,
      // then open the drawer with the fresh contents.
      return fetchCart().then(function (cart) {
        renderDrawer(cart);
        showDrawer();
        return cart;
      });
    }).catch(function (e) {
      toast((e && e.description) || (e && e.message) || 'Could not add to bag');
    });
  }
  window.vyAddItems = addItems;
  window.vyRefreshCart = refreshDrawer;

  /* ───────────────────── Mobile nav (hamburger) ─────────────────────
     Both brand headers render the same Shopify menu twice: inline for
     desktop and in a [data-mobnav] panel for < 720px. */
  var mobToggle = document.querySelector('[data-mobnav-toggle]');
  var mobNav = document.querySelector('[data-mobnav]');
  function closeMobNav() {
    if (!mobNav || mobNav.hidden) return;
    mobNav.hidden = true;
    mobToggle && mobToggle.setAttribute('aria-expanded', 'false');
    document.documentElement.classList.remove('vy-mobnav-open');
  }
  function openMobNav() {
    if (!mobNav) return;
    mobNav.hidden = false;
    mobToggle && mobToggle.setAttribute('aria-expanded', 'true');
    document.documentElement.classList.add('vy-mobnav-open');
  }
  if (mobToggle && mobNav) {
    mobToggle.addEventListener('click', function () {
      mobNav.hidden ? openMobNav() : closeMobNav();
    });
    mobNav.addEventListener('click', function (e) { if (e.target.closest('a')) closeMobNav(); });
    window.addEventListener('resize', function () { if (window.innerWidth >= 720) closeMobNav(); });
  }

  /* ───────────────────── Alkemia bar search ───────────────────── */
  document.querySelectorAll('[data-search]').forEach(function (form) {
    var toggle = form.querySelector('[data-search-toggle]');
    var input = form.querySelector('input[type="search"]');
    if (!toggle || !input) return;
    function open() { form.classList.add('is-open'); toggle.setAttribute('aria-expanded', 'true'); input.focus(); }
    function close() { form.classList.remove('is-open'); toggle.setAttribute('aria-expanded', 'false'); }
    toggle.addEventListener('click', function () {
      if (!form.classList.contains('is-open')) return open();
      if (input.value.trim()) form.submit(); else close();
    });
    input.addEventListener('keydown', function (e) { if (e.key === 'Escape') close(); });
    document.addEventListener('click', function (e) { if (!form.contains(e.target)) close(); });
    if (input.value) open();
  });

  /* ───────────────────── Global click handling ───────────────────── */
  document.addEventListener('click', function (e) {
    var t;

    // Open / close drawer
    if (e.target.closest('[data-cart-open]')) { e.preventDefault(); openDrawer(); return; }
    if (e.target.closest('[data-cart-close]') || e.target === scrim) { closeDrawer(); return; }

    // Drawer line qty
    t = e.target.closest('[data-line-minus],[data-line-plus],[data-line-remove]');
    if (t) {
      var lineEl = t.closest('[data-line]');
      var line = parseInt(lineEl.dataset.line, 10);
      var qtyEl = lineEl.querySelector('.vy-line__qty span');
      var q = qtyEl ? parseInt(qtyEl.textContent, 10) : 1;
      if (t.hasAttribute('data-line-remove')) changeLine(line, 0);
      else if (t.hasAttribute('data-line-minus')) changeLine(line, Math.max(0, q - 1));
      else changeLine(line, q + 1);
      return;
    }

    // Quick add buttons: data-add-id (variant id), optional data-add-qty, data-add-name
    t = e.target.closest('[data-add-id]');
    if (t) {
      e.preventDefault();
      e.stopPropagation();
      var ids = String(t.dataset.addId).split(',');
      var items = ids.map(function (id) {
        return { id: parseInt(id, 10), quantity: parseInt(t.dataset.addQty || '1', 10) };
      });
      addItems(items, (t.dataset.addName || 'Added') + ' — in your bag');
      return;
    }

    // Qty steppers (PDP)
    t = e.target.closest('[data-qty-minus],[data-qty-plus]');
    if (t) {
      var wrap = t.closest('.vy-qty');
      var input = wrap && wrap.querySelector('input[name="quantity"]');
      if (input) {
        var v = parseInt(input.value, 10) || 1;
        input.value = t.hasAttribute('data-qty-minus') ? Math.max(1, v - 1) : v + 1;
      }
      return;
    }
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') { closeDrawer(); closeMobNav(); }
  });

  /* ───────────────────── Product forms (PDP add to bag) ───────────────────── */
  document.addEventListener('submit', function (e) {
    var form = e.target.closest('form[data-product-form]');
    if (!form) return;
    e.preventDefault();
    var id = parseInt(form.querySelector('[name="id"]').value, 10);
    var qtyInput = form.querySelector('[name="quantity"]');
    var qty = qtyInput ? Math.max(1, parseInt(qtyInput.value, 10) || 1) : 1;
    addItems([{ id: id, quantity: qty }], (form.dataset.productTitle || 'Product') + ' ×' + qty + ' added to your bag');
  });

  /* ───────────────────── VYBES page background switch ─────────────────────
     The whole page is red while the hero is on screen. Once the hero's
     bottom edge rises above 55% of the viewport (i.e. the marquee is
     mid-screen), <html> gets .past-hero and the page fades to cream.
     Scrolling back up brings the red back. Mirrors the Claude Design build. */
  var heroSection = document.querySelector('[data-hero-watch]');
  var heroZone = document.querySelector('[data-hero-zone]');
  if (heroSection) {
    var root = document.documentElement;
    root.classList.add('vy-hero-page');
    var pastHero = null;
    var ticking = false;
    function updateHeroBg() {
      ticking = false;
      var past = heroSection.getBoundingClientRect().bottom <= window.innerHeight * 0.55;
      if (past === pastHero) return;
      pastHero = past;
      root.classList.toggle('past-hero', past);
      if (heroZone) heroZone.classList.toggle('past-hero', past);
    }
    function onScroll() {
      if (!ticking) { ticking = true; requestAnimationFrame(updateHeroBg); }
    }
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll);
    updateHeroBg();
  }

  /* ───────────────────── Oils accordion ───────────────────── */
  document.querySelectorAll('[data-oils]').forEach(function (root) {
    var cards = Array.prototype.slice.call(root.querySelectorAll('[data-oil-card]'));
    if (!cards.length) return;
    var current = 0;

    /* Accent wash: hex comes from Liquid via data-accent, rgba is built here */
    cards.forEach(function (c) {
      var rgb = hexToRgb(c.dataset.accent);
      if (rgb) c.style.setProperty('--oil-wash', 'radial-gradient(900px 600px at 78% 30%,rgba(' + rgb + ',.22),transparent 60%)');
    });

    /* Carousel window: at most WINDOW cards are on stage at once. With more
       products in a tab, tapping a card near the right edge slides the window
       right (next card enters, leftmost leaves); tapping the leftmost slides
       it back. Arrows wrap around. */
    var WINDOW = Math.max(2, parseInt(root.dataset.window || '4', 10));
    var start = 0;
    var dotsEl = root.querySelector('[data-oil-dots]');

    function visible() {
      var group = root.dataset.activeGroup || 'a';
      return cards.filter(function (c) { return (c.dataset.group || 'a') === group; });
    }
    function clamp(v, lo, hi) { return Math.max(lo, Math.min(hi, v)); }
    function apply(idx) {
      var vis = visible();
      var n = vis.length;
      if (!n) return;
      current = ((idx % n) + n) % n;
      if (n > WINDOW) {
        var maxStart = n - WINDOW;
        var pos = current - start;
        if (current < start || current >= start + WINDOW) {
          start = clamp(current - 1, 0, maxStart);             // came from an arrow / wrap-around
        } else if (pos >= WINDOW - 2 && start < maxStart) {
          start = clamp(current - 1, 0, maxStart);             // 3rd/4th card tapped → slide right
        } else if (pos === 0 && start > 0) {
          start = clamp(current - 1, 0, maxStart);             // leftmost tapped → slide back
        }
      } else {
        start = 0;
      }
      vis.forEach(function (c, i) {
        c.classList.toggle('is-active', i === current);
        c.classList.toggle('is-offstage', n > WINDOW && (i < start || i >= start + WINDOW));
      });
      if (dotsEl) {
        if (n > WINDOW) {
          dotsEl.innerHTML = vis.map(function (_, i) {
            return '<button type="button" class="vy-oils__dot" data-oil-dot="' + i + '" tabindex="-1"' + (i === current ? ' aria-current="true"' : '') + '></button>';
          }).join('');
        } else {
          dotsEl.innerHTML = '';
        }
      }
    }
    function setGroup(g) {
      root.dataset.activeGroup = g;
      start = 0;
      cards.forEach(function (c) {
        c.style.display = (c.dataset.group || 'a') === g ? '' : 'none';
      });
      apply(0);
    }

    root.addEventListener('click', function (e) {
      var tab = e.target.closest('[data-oil-group]');
      if (tab) {
        root.querySelectorAll('[data-oil-group]').forEach(function (b) {
          b.setAttribute('aria-pressed', b === tab ? 'true' : 'false');
        });
        setGroup(tab.dataset.oilGroup);
        return;
      }
      if (e.target.closest('[data-oil-prev]')) { apply(current - 1); return; }
      if (e.target.closest('[data-oil-next]')) { apply(current + 1); return; }
      var dot = e.target.closest('[data-oil-dot]');
      if (dot) { apply(parseInt(dot.dataset.oilDot, 10)); return; }
      var card = e.target.closest('[data-oil-card]');
      if (card && !e.target.closest('a,button,form')) {
        var vis = visible();
        apply(vis.indexOf(card));
      }
    });

    /* Hover-to-open on pointer devices (desktop). Touch keeps tap. Uses
       mousemove (not mouseover) so a card sliding under a *still* cursor
       during the flex transition never re-triggers, plus a short settle
       delay and a post-open lock so the accordion can't flap. */
    if (window.matchMedia && window.matchMedia('(hover: hover) and (pointer: fine)').matches) {
      var hoverTimer = null, lastX = -1, lastY = -1, lockUntil = 0;
      root.addEventListener('mousemove', function (e) {
        if (Math.abs(e.clientX - lastX) < 3 && Math.abs(e.clientY - lastY) < 3) return;
        lastX = e.clientX; lastY = e.clientY;
        clearTimeout(hoverTimer);
        if (Date.now() < lockUntil) return;
        var card = e.target.closest('[data-oil-card]');
        if (!card || card.classList.contains('is-active') || card.classList.contains('is-offstage')) return;
        hoverTimer = setTimeout(function () {
          var i = visible().indexOf(card);
          if (i > -1) { apply(i); lockUntil = Date.now() + 700; }
        }, 80);
      }, { passive: true });
      root.addEventListener('mouseleave', function () { clearTimeout(hoverTimer); });
    }

    setGroup(root.dataset.activeGroup || 'a');
  });

  /* ───────────────────── Jalupro category chips ───────────────────── */
  document.querySelectorAll('[data-line-filter]').forEach(function (root) {
    root.addEventListener('click', function (e) {
      var chip = e.target.closest('[data-filter-cat]');
      if (!chip) return;
      var cat = chip.dataset.filterCat;
      root.querySelectorAll('[data-filter-cat]').forEach(function (b) {
        b.setAttribute('aria-pressed', b === chip ? 'true' : 'false');
      });
      root.querySelectorAll('[data-cat]').forEach(function (card) {
        card.style.display = (cat === 'all' || card.dataset.cat === cat) ? '' : 'none';
      });
    });
  });

  /* ───────────────────── Bundle builder ───────────────────── */
  document.querySelectorAll('[data-bundle]').forEach(function (root) {
    var discounts = root.dataset.discounts !== 'false';
    /* Tiered savings preview. Mirrors the automatic discounts in Shopify
       (Duo / Trio / Quad / Quint, min qty 2 / 3 / 4 / 5). A tier set to 0
       in the editor inherits the tier below it, so the preview never drops. */
    var duoPct = discounts ? parseInt(root.dataset.duoDiscount || '10', 10) : 0;
    var trioPct = discounts ? parseInt(root.dataset.trioDiscount || '15', 10) : 0;
    var quadPct = discounts ? (parseInt(root.dataset.quadDiscount || '0', 10) || trioPct) : 0;
    var quintPct = discounts ? (parseInt(root.dataset.quintDiscount || '0', 10) || quadPct) : 0;
    function tierPct(n) {
      if (n >= 5) return quintPct;
      if (n === 4) return quadPct;
      if (n === 3) return trioPct;
      if (n === 2) return duoPct;
      return 0;
    }
    function tierName(n) {
      if (n >= 5) return 'Quint perk';
      if (n === 4) return 'Quad perk';
      if (n === 3) return 'Trio perk';
      if (n === 2) return 'Duo perk';
      return 'Bundle perk';
    }
    var minItems = Math.max(1, parseInt(root.dataset.minItems || '2', 10));
    var maxSlots = parseInt(root.dataset.maxSlots || '5', 10);
    var giftId = root.dataset.giftVariant ? parseInt(root.dataset.giftVariant, 10) : null;
    var giftName = root.dataset.giftName || 'Gift Box';
    var slots = []; // {id, name, price (cents), img, color}

    var slotEls = Array.prototype.slice.call(root.querySelectorAll('[data-slot]'));
    var hintEl = root.querySelector('[data-bundle-hint]');
    var countEl = root.querySelector('[data-bundle-count]');
    var subEl = root.querySelector('[data-bundle-sub]');
    var saveEl = root.querySelector('[data-bundle-save]');
    var perkEl = root.querySelector('[data-bundle-perk]');
    var totalEl = root.querySelector('[data-bundle-total]');
    var ctaEls = root.querySelectorAll('[data-bundle-cta]');
    var addBtn = root.querySelector('[data-bundle-add]');
    var giftBtn = root.querySelector('[data-bundle-add-gift]');
    var burstEl = root.querySelector('[data-bundle-burst]');
    var itemsWrap = root.querySelector('[data-bundle-items]');
    var items = Array.prototype.slice.call(root.querySelectorAll('[data-bundle-item]'));

    /* Hint under the tray, by item count. Only nudges toward the next tier
       when that tier is actually better than the current one. */
    function hintFor(n) {
      if (!discounts) {
        return [
          'Pick your oils to start your bundle',
          'Nice start. Add another mood',
          'Nice duo. Room for more',
          'A trio. Room for two more',
          'Four in. One slot left',
          'Full tray. Maximum vybe.'
        ][Math.min(n, 5)];
      }
      if (n === 0) return 'Pick any two oils to start your bundle';
      if (n === 1) return 'One more unlocks ' + duoPct + '% off';
      if (n === 2) return trioPct > duoPct ? 'Nice duo. A third takes you to ' + trioPct + '% off' : 'Nice duo at ' + duoPct + '% off. Room for more';
      if (n === 3) return quadPct > trioPct ? 'Trio unlocked at ' + trioPct + '%. A fourth takes you to ' + quadPct + '%' : 'Trio unlocked at ' + trioPct + '%. Room for two more';
      if (n === 4) return quintPct > quadPct ? 'Four in at ' + quadPct + '%. One more unlocks ' + quintPct + '% off' : 'Four in at ' + quadPct + '%. One slot left';
      return 'Full tray at ' + quintPct + '% off. Maximum vybe.';
    }
    var emptyLabels = [
      root.dataset.slotLabel0 || 'Pick a vybe',
      root.dataset.slotLabel1 || 'Pick a vybe',
      root.dataset.slotLabel2 || 'Make it three',
      root.dataset.slotLabel3 || 'Room for more',
      root.dataset.slotLabel4 || 'Room for more',
      root.dataset.slotLabel5 || 'Room for more'
    ];

    /* Tabs: show only the items of the active group */
    function setGroup(g) {
      if (itemsWrap) itemsWrap.dataset.activeGroup = g;
      items.forEach(function (it) {
        it.style.display = (it.dataset.group || 'a') === g ? '' : 'none';
      });
    }
    var tabs = root.querySelectorAll('[data-bundle-group]');
    if (tabs.length) {
      root.addEventListener('click', function (e) {
        var tab = e.target.closest('[data-bundle-group]');
        if (!tab) return;
        tabs.forEach(function (b) { b.setAttribute('aria-pressed', b === tab ? 'true' : 'false'); });
        if (itemsWrap) {
          itemsWrap.classList.add('is-switching');
          setTimeout(function () { setGroup(tab.dataset.bundleGroup); itemsWrap.classList.remove('is-switching'); }, 220);
        } else {
          setGroup(tab.dataset.bundleGroup);
        }
      });
    }
    setGroup((itemsWrap && itemsWrap.dataset.activeGroup) || 'a');

    function render() {
      var n = slots.length;
      slotEls.forEach(function (el, i) {
        var s = slots[i];
        if (s) {
          el.innerHTML =
            '<div class="vy-slot__disc vy-slot__disc--filled" style="background:' + s.color + '">' +
            '<div class="vy-slot__img" style="background-image:url(' + JSON.stringify(s.img).slice(1, -1) + ')"></div>' +
            '<button type="button" class="vy-slot__remove" data-slot-remove="' + i + '" aria-label="Remove from bundle">×</button>' +
            '</div><span class="vy-slot__name">' + escapeHtml(s.name) + '</span>';
        } else {
          el.innerHTML =
            '<div class="vy-slot__disc vy-slot__disc--empty"><span class="vy-star vy-star--outline" aria-hidden="true"></span></div>' +
            '<span class="vy-slot__hintlabel">' + escapeHtml(emptyLabels[i] || 'Room for more') + '</span>';
        }
      });
      var pct = tierPct(n);
      var sub = slots.reduce(function (a, s) { return a + s.price; }, 0);
      var save = Math.round(sub * pct / 100);
      if (countEl) countEl.textContent = n;
      if (hintEl) hintEl.textContent = hintFor(n);
      if (subEl) subEl.textContent = n ? formatMoney(sub) : '—';
      if (saveEl) saveEl.textContent = save ? '−' + formatMoney(save) : '—';
      if (perkEl) perkEl.textContent = pct ? tierName(n) + ' (−' + pct + '%)' : 'Bundle perk';
      if (totalEl) totalEl.textContent = n ? formatMoney(sub - save) : formatMoney(0);
      ctaEls.forEach(function (el) {
        if (n < minItems) el.setAttribute('data-dim', ''); else el.removeAttribute('data-dim');
      });
      if (addBtn) addBtn.disabled = n < minItems;
      if (giftBtn) giftBtn.disabled = n < minItems;
      root.querySelectorAll('[data-bundle-pick]').forEach(function (b) {
        b.style.opacity = n >= maxSlots ? '.4' : '';
      });
    }

    function burstThen(cb) {
      if (burstEl) {
        burstEl.hidden = false;
        setTimeout(function () { burstEl.hidden = true; slots = []; render(); cb(); }, 1200);
      } else { slots = []; render(); cb(); }
    }

    root.addEventListener('click', function (e) {
      var pick = e.target.closest('[data-bundle-pick]');
      if (pick) {
        if (slots.length >= maxSlots) { toast(root.dataset.fullMsg || "Tray's full. " + maxSlots + " max"); return; }
        slots.push({
          id: parseInt(pick.dataset.variantId, 10),
          name: pick.dataset.name,
          price: parseInt(pick.dataset.price, 10),
          img: pick.dataset.img,
          color: pick.dataset.color || '#ec0000'
        });
        render();
        return;
      }
      var rm = e.target.closest('[data-slot-remove]');
      if (rm) {
        slots.splice(parseInt(rm.dataset.slotRemove, 10), 1);
        render();
        return;
      }
    });

    /* Add bundle → cart */
    if (addBtn) addBtn.addEventListener('click', function () {
      if (slots.length < minItems) return;
      var lines = slots.map(function (s) { return { id: s.id, quantity: 1 }; });
      var n = slots.length;
      burstThen(function () {
        addItems(lines, 'Bundle of ' + n + ' added to your bag');
      });
    });

    /* Add bundle + Gift Box → cart (single /cart/add.js call: tray items + gift box variant) */
    if (giftBtn) giftBtn.addEventListener('click', function () {
      if (slots.length < minItems) return;
      if (!giftId) { toast('Gift box is not available right now'); return; }
      var lines = slots.map(function (s) { return { id: s.id, quantity: 1 }; });
      lines.push({ id: giftId, quantity: 1 });
      var n = slots.length;
      burstThen(function () {
        addItems(lines, 'Bundle of ' + n + ' packed in a ' + giftName + '. Added to your bag');
      });
    });

    render();
  });

  /* ───────────────────── PDP gallery thumbs ───────────────────── */
  document.querySelectorAll('[data-gallery]').forEach(function (root) {
    var main = root.querySelector('[data-gallery-main]');
    root.addEventListener('click', function (e) {
      var th = e.target.closest('[data-gallery-thumb]');
      if (!th || !main) return;
      main.src = th.dataset.full;
      root.querySelectorAll('[data-gallery-thumb]').forEach(function (b) {
        b.setAttribute('aria-current', b === th ? 'true' : 'false');
      });
    });
  });

  /* ───────────────────── Newsletter toast ───────────────────── */
  document.querySelectorAll('form.vy-newsletter').forEach(function (form) {
    form.addEventListener('submit', function () {
      try { sessionStorage.setItem('vy-nl', '1'); } catch (err) { /* private mode */ }
    });
  });
})();
